import { createContext, useContext } from 'react';

export const BatchListContext = createContext<() => void>(() => {
  throw new Error('useBatchList must be used within a BatchListProvider');
});

export const useBatchList = () => useContext(BatchListContext);
